import { VyTable } from '../../../../../../../components/new-design/table/vy-table/VyTable';
import { useInvitations } from '../../../../../../../hooks/requests/use-invitations';
import { isEmptyArray } from '@vy/utils';
import { INVITATIONS_COLUMNS } from './invitations-table-components/InvitationsColumns';
import { Box, Stack, Typography } from '@mui/material';

export const InvitationsTable: React.FC = () => {
  const { data } = useInvitations({ suspense: true });
  const invitationItems = data?.invitations ?? [];

  if (isEmptyArray(invitationItems)) {
    return null;
  }

  return (
    <Stack
      direction="row"
      sx={{
        gap: 4,
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap"
      }}>
      <Box>
        <Typography>Pending Invitations</Typography>
        <Typography variant="body2" sx={{
          color: "text.secondary"
        }}>
          Members who have been invited but haven't joined yet
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', maxWidth: 1000, width: '100%', overflowX: 'auto' }}>
        <VyTable
          tableName="settings-invitations"
          itemsCount={invitationItems.length}
          showPagination={false}
          disableColumnResize
          items={invitationItems}
          columns={INVITATIONS_COLUMNS}
          sx={{
            minHeight: '150px',
          }}
        />
      </Box>
    </Stack>
  );
};
